import {
  HAS_CREEP_FEEDING,
  HAS_PASTURES,
  LIST_FARMS,
  SET_FARM,
  SET_MAP_CENTER_COORDS,
  UPDATE_CONCILIATION_DATE,
  UPDATE_FARM_BENCHMARK_PARTICIPATION,
} from "redux/actions/actionsConstants";
import { getFarmStateFromStorage } from "shared/storageUtils";
import type { Fazenda, ToggleFeature } from "shared/types";
import { FarmDispatchAction } from "../actions/farmActions";

export type Coordinate = { lat: number; lng: number };

export type FarmState = {
  centroMapa: Coordinate;
  currentFarm: Fazenda | null;
  DataInicioConciliacao: string | null;
  DropdownBloqueado: boolean;
  Fazendas: Fazenda[];
  FazendaSelecionada: number | null;
  TemCochoCreep: boolean;
  TemPastos: boolean;
  Toggles: ToggleFeature[];
};

const prodapCoords = {
  lat: -19.9211964,
  lng: -43.948999,
} satisfies FarmState["centroMapa"];

const storedFarmState = getFarmStateFromStorage<FarmState>();

export const initialState: FarmState = {
  Fazendas: storedFarmState?.Fazendas ?? [],
  FazendaSelecionada: storedFarmState?.FazendaSelecionada ?? null,
  centroMapa: prodapCoords,
  TemPastos: false,
  DropdownBloqueado: false,
  TemCochoCreep: false,
  Toggles: storedFarmState?.Toggles ?? [],
  DataInicioConciliacao: storedFarmState?.DataInicioConciliacao ?? null,
  currentFarm:
    (storedFarmState?.Fazendas ?? []).find(
      (item) => item.IdFazenda === storedFarmState?.FazendaSelecionada
    ) ?? null,
};

function farmReducer(
  state: FarmState = initialState,
  action: FarmDispatchAction
): FarmState {
  if (action.type === SET_MAP_CENTER_COORDS) {
    return { ...state, centroMapa: action.payload };
  }

  if (action.type === SET_FARM) {
    const selectedFarm = state.Fazendas.find(
      (f) => f.IdFazenda === action.payload.farmId
    );

    return {
      ...state,
      FazendaSelecionada: action.payload.farmId,
      Toggles: action.payload.toggles,
      currentFarm: selectedFarm ?? null,
      DataInicioConciliacao: selectedFarm?.DataInicioConciliacao ?? null,
    };
  }

  if (action.type === LIST_FARMS) {
    const selectedFarm = action.payload.farms.find(
      (f) => f.IdFazenda === action.payload.farmId
    );

    return {
      ...state,
      Fazendas: action.payload.farms,
      FazendaSelecionada: action.payload.farmId,
      currentFarm: selectedFarm ?? null,
    };
  }

  if (action.type === UPDATE_CONCILIATION_DATE) {
    return {
      ...state,
      DataInicioConciliacao: action.payload.conciliationStartDate,
    };
  }

  if (action.type === HAS_PASTURES) {
    return { ...state, TemPastos: action.payload };
  }

  if (action.type === HAS_CREEP_FEEDING) {
    return { ...state, TemCochoCreep: action.payload };
  }

  if (action.type === UPDATE_FARM_BENCHMARK_PARTICIPATION) {
    if (!state.currentFarm) {
      return state;
    }

    const updatedFarm = {
      ...state.currentFarm,
      ParticipacaoBenchmark: action.payload.participacaoBenchmark,
    };

    const updatedFazendas = state.Fazendas.map((fazenda) =>
      fazenda.IdFazenda === state.currentFarm?.IdFazenda
        ? {
            ...fazenda,
            ParticipacaoBenchmark: action.payload.participacaoBenchmark,
          }
        : fazenda
    );

    return {
      ...state,
      currentFarm: updatedFarm,
      Fazendas: updatedFazendas,
    };
  }

  return { ...state };
}

export default farmReducer;
